/* ==============================================================================================
 *  ICONS HELPER
 * ============================================================================================== */

var Sushi, Icons;

(function (Sushi, Icons) {
	"use strict";

	/**
	 * @param {string} html
	 * @param {object} options
	 * @return {string}
	 */
	Icons.Wrap = function (html, options) {
		return "<svg "
			+ "width='" + options.width + "' "
			+ "height='" + options.height + "' "
			+ "viewBox='" + options.viewbox + "' "
			+ "fill='none' "
			+ "xmlns='http://www.w3.org/2000/svg'>" + html + "</svg>";
	};

	Icons.tooltip = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M14 8C14 4.68629 11.3137 2 8 2C4.68628 2 2 4.68629 2 8C2 11.3137 4.68628 14 8 14C11.3137 14 14 11.3137 14 8ZM9 4V6H7V4H9ZM9 12V7H7V12H9Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 16,
			height: 16,
			viewbox: "0 0 16 16",
		});
	};

	Icons.remove = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M5.70715 5.00001L10 0.707123L9.29292 1.59144e-05L5.00004 4.2929L0.707131 0L2.31862e-05 0.707107L4.29294 5.00001L3.82066e-05 9.29289L0.707145 10L5.00004 5.70711L9.29292 10L10 9.29289L5.70715 5.00001Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 10,
			height: 10,
			viewbox: "0 0 10 10",
		});
	};

	Icons.arrowRight = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M5 10L4.29289 9.29289L8.08579 5.5L-3.42129e-06 5.5L-3.33387e-06 4.5L8.08579 4.5L4.29289 0.707107L5 -4.37114e-07L10 5L5 10Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 10,
			height: 10,
			viewbox: "0 0 10 10",
		});
	};

	Icons.check = function () {
		var i = "<path d='M3.80282 6.64865L1.1831 4.13514L0 5.27027L3.80282 9L12 1.13514L10.8169 0L3.80282 6.64865Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 12,
			height: 9,
			viewbox: "0 0 12 9",
		});
	};

	Icons.fileCheck = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M14 13H4V1H12V3H14V13ZM15 3V14H3V0H12H13L15 2V3Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M3 2H1V16H13V14H12V15H2V3H3V2Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M6 8.70714L6.70711 8.00003L7.99998 9.29292L11.2929 6L12 6.70711L7.99998 10.7071L6 8.70714Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 16,
			height: 16,
			viewbox: "0 0 16 16",
		});
	};

	Icons.fileCSV = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M3 15H13V14H14V16H2V14H3V15ZM13 5V3H11V1H3V5H2V0H11H12L14 2V3V5H13Z' fill='currentColor'/>"
			+ "<path d='M0.5 5.5H15.5V13.5H0.5V5.5Z' stroke='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M9 7H6V10H8V11H6V12H9V9H7V8H9V7Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M11 7H10L11 12H13L14 7H13L12.2 11H11.8L11 7Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M2 7H5V8H3V11H5V12H2V7Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 16,
			height: 16,
			viewbox: "0 0 16 16",
		});
	};

	Icons.filePDF = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M3 15H13V14H14V16H2V14H3V15ZM13 5V3H11V1H3V5H2V0H11H12L14 2V3V5H13Z' fill='currentColor'/>"
			+ "<path d='M0.5 5.5H15.5V13.5H0.5V5.5Z' stroke='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M2 7V12H3V10H5V7H2ZM4 8V9H3V8H4Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M6 7H9V8H7V11H9V12H6V7ZM9 11H10V8H9V11Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M11 7V12H12V10H14V9H12V8H14V7H11Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 16,
			height: 16,
			viewbox: "0 0 16 16",
		});
	};

	Icons.fileXLS = function () {
		var i = "<path fill-rule='evenodd' clip-rule='evenodd' d='M3 15H13V14H14V16H2V14H3V15ZM13 5V3H11V1H3V5H2V0H11H12L14 2V3V5H13Z' fill='currentColor'/>"
			+ "<path d='M0.5 5.5H15.5V13.5H0.5V5.5Z' stroke='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M3.42267 9.50003L2 7H3.15466L4 8.48547L4.84534 7H6L4.57733 9.50003L6 12H4.84528L4 10.5146L3.15472 12H2L3.42267 9.50003Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M8 11H10V12H7V7H8V11Z' fill='currentColor'/>"
			+ "<path fill-rule='evenodd' clip-rule='evenodd' d='M14 7H11V10H13V11H11V12H14V9H12V8H14V7Z' fill='currentColor'/>";

		return Icons.Wrap(i, {
			width: 16,
			height: 16,
			viewbox: "0 0 16 16",
		});
	};

})(Sushi || (Sushi = {}), Icons || (Icons = {}));
